import React from "react";
import { PulseLoader } from "react-spinners";

const LoadingScreen: React.FC = () => {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-white font-outfit">
      <div className="flex flex-col items-center space-y-4">
        <PulseLoader color="#24C0BE" size={15} />
        <p className="text-[#24C0BE] font-semibold text-lg">
          Loading portal...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
